export const ATTENDANCE_TYPE_OBJECT = {
  SOPA: {
    label: 'SOAP',
  },
  FINISH_ATTENDANCE: {
    label: 'Finalizar atendimento',
  },
}
